import React from "react";
import { useDrop } from "react-dnd";
import styled from "styled-components";
import { injectIntl } from "react-intl";

const Wrapper = styled.div`
  display: flex;
  position: relative;
  color: #e68797;
  min-height: 160px;
  height: 100%;
  width: 100%;
  text-align: center;
  justify-content: flex-start;
  flex-direction: column;
  background: repeating-linear-gradient(
    45deg,
    #fff,
    #fff 3px,
    #f1f1f1 3px,
    #f1f1f1 6px
  );
  border-radius: 5px;
`;

const Top = styled.div`
  display: flex;
  flex: 1;
`;

const Bottom = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding-right: 8px;
  margin-bottom: 8px;
`;

const AddButton = styled.button`
  padding-bottom: 4px;
  background-color: #fff;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  font-size: 24px;
  color: #777;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);
  border-radius: 10px;

  &:focus {
    outline: none;
  }
`;

const DropBox = styled.div`
  min-height: 40px;
  background: ${(p) => p.theme.colors.info};
  color: ${(p) => p.theme.colors.on.info};
  border: 1px solid ${(p) => p.theme.colors.border.info};
  border-radius: 8px;
  width: 100%;
  margin: 16px 16px;
  display: flex;
  align-items: center;
  font-weight: bold;
  justify-content: center;
  flex: 1;
  display: flex;

  & > i {
    margin-right: 8px;
  }
`;

const EmptyColumnPlaceholder = injectIntl((props) => {
  const { id, DropZone, fb3ClickMove, moveMode, select, intl, nodes } = props;
  const [{ isOver }, drop] = useDrop(
    () => ({
      accept: "component",
      drop: (item) => {
        const { action } = item;

        if (action === "create") {
          const { name, type, defaultExtra } = item;

          // alert('create')
          props.fb3Add({
            component: {
              name: type,
              extra: {
                label: name,
                name,
                ...defaultExtra,
              },
            },
            parent: id,
          });
        }

        if (item.nodeId !== id) {
          fb3ClickMove({ src: item.nodeId, dst: id, parentId: item.parentId });
        }
      },
      collect: (monitor) => ({
        isOver: !!monitor.isOver(),
      }),
    }),
    [id]
  );

  return (
    <Wrapper ref={drop}>
      <Top>
        {isOver && (
          <DropBox>
            <i className="fa-regular fa-hand fa-beat"></i>{" "}
            {intl.formatMessage({ id: "Drop to move" })}
          </DropBox>
        )}
        {moveMode && (
          <DropZone
            onClick={(e) => {
              e.stopPropagation();
              const nodeParentId = Object.keys(nodes).find((id) => {
                const node = nodes[id];
                return (
                  node.type === "Col" &&
                  node.structure?.includes(props.moveMode)
                );
              });
              fb3ClickMove({ src: moveMode, dst: id, parentId: nodeParentId });
            }}
          />
        )}
      </Top>
      <Bottom>
        {
          <AddButton
            data-id={id}
            data-mode="add"
            data-position="center"
            data-overlayposition="absolute"
            onClick={select}
            aria-label="Add component"
          >
            +
          </AddButton>
        }
      </Bottom>
    </Wrapper>
  );
});

export default EmptyColumnPlaceholder;
